/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiGenderAndSterilizationV2,
  ApiGenderAndSterilizationV2FromJSON,
  ApiGenderAndSterilizationV2FromJSONTyped,
  ApiGenderAndSterilizationV2ToJSON,
} from './ApiGenderAndSterilizationV2';
import {
  ApiPetBreed,
  ApiPetBreedFromJSON,
  ApiPetBreedFromJSONTyped,
  ApiPetBreedToJSON,
} from './ApiPetBreed';
import {
  ApiPetBreedSize,
  ApiPetBreedSizeFromJSON,
  ApiPetBreedSizeFromJSONTyped,
  ApiPetBreedSizeToJSON,
} from './ApiPetBreedSize';
import {
  ApiPetMedicalCondition,
  ApiPetMedicalConditionFromJSON,
  ApiPetMedicalConditionFromJSONTyped,
  ApiPetMedicalConditionToJSON,
} from './ApiPetMedicalCondition';
import {
  ApiPetMedication,
  ApiPetMedicationFromJSON,
  ApiPetMedicationFromJSONTyped,
  ApiPetMedicationToJSON,
} from './ApiPetMedication';
import {
  ApiPetMedicationAllergy,
  ApiPetMedicationAllergyFromJSON,
  ApiPetMedicationAllergyFromJSONTyped,
  ApiPetMedicationAllergyToJSON,
} from './ApiPetMedicationAllergy';
import {
  ApiPetTypeReference,
  ApiPetTypeReferenceFromJSON,
  ApiPetTypeReferenceFromJSONTyped,
  ApiPetTypeReferenceToJSON,
} from './ApiPetTypeReference';
import {
  ApiPetTypeV2FormConfig,
  ApiPetTypeV2FormConfigFromJSON,
  ApiPetTypeV2FormConfigFromJSONTyped,
  ApiPetTypeV2FormConfigToJSON,
} from './ApiPetTypeV2FormConfig';
import {
  ApiSubmitter,
  ApiSubmitterFromJSON,
  ApiSubmitterFromJSONTyped,
  ApiSubmitterToJSON,
} from './ApiSubmitter';

/**
 *
 * @export
 * @interface ApiFormFieldCheckboxValue
 */
export interface ApiFormFieldCheckboxValue {
  /**
   *
   * @type {number}
   * @memberof ApiFormFieldCheckboxValue
   */
  id: number;
  /**
   *
   * @type {ApiSubmitter}
   * @memberof ApiFormFieldCheckboxValue
   */
  submitter?: ApiSubmitter;
  /**
   *
   * @type {string}
   * @memberof ApiFormFieldCheckboxValue
   */
  name: string;
  /**
   * Only modifiable during update.
   * @type {boolean}
   * @memberof ApiFormFieldCheckboxValue
   */
  markForDelete?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiFormFieldCheckboxValue
   */
  pharmacyEligible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiFormFieldCheckboxValue
   */
  vetDietEligible?: boolean;
  /**
   *
   * @type {ApiPetBreedSize}
   * @memberof ApiFormFieldCheckboxValue
   */
  size?: ApiPetBreedSize;
  /**
   *
   * @type {ApiPetTypeReference}
   * @memberof ApiFormFieldCheckboxValue
   */
  type: ApiPetTypeReference;
  /**
   *
   * @type {string}
   * @memberof ApiFormFieldCheckboxValue
   */
  gender: ApiFormFieldCheckboxValueGenderEnum;
  /**
   *
   * @type {boolean}
   * @memberof ApiFormFieldCheckboxValue
   */
  sterilization: boolean;
}

/**
 * @export
 */
export const ApiFormFieldCheckboxValueGenderEnum = {
  Unknown: 'UNKNOWN',
  Male: 'MALE',
  Female: 'FEMALE',
} as const;
export type ApiFormFieldCheckboxValueGenderEnum = typeof ApiFormFieldCheckboxValueGenderEnum[keyof typeof ApiFormFieldCheckboxValueGenderEnum];

export function ApiFormFieldCheckboxValueFromJSON(json: any): ApiFormFieldCheckboxValue {
  return ApiFormFieldCheckboxValueFromJSONTyped(json, false);
}

export function ApiFormFieldCheckboxValueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiFormFieldCheckboxValue {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    submitter: !exists(json, 'submitter') ? undefined : ApiSubmitterFromJSON(json['submitter']),
    name: json['name'],
    markForDelete: !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
    pharmacyEligible: !exists(json, 'pharmacyEligible') ? undefined : json['pharmacyEligible'],
    vetDietEligible: !exists(json, 'vetDietEligible') ? undefined : json['vetDietEligible'],
    size: !exists(json, 'size') ? undefined : ApiPetBreedSizeFromJSON(json['size']),
    type: ApiPetTypeReferenceFromJSON(json['type']),
    gender: json['gender'],
    sterilization: json['sterilization'],
  };
}

export function ApiFormFieldCheckboxValueToJSON(value?: ApiFormFieldCheckboxValue | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    submitter: ApiSubmitterToJSON(value.submitter),
    name: value.name,
    markForDelete: value.markForDelete,
    pharmacyEligible: value.pharmacyEligible,
    vetDietEligible: value.vetDietEligible,
    size: ApiPetBreedSizeToJSON(value.size),
    type: ApiPetTypeReferenceToJSON(value.type),
    gender: value.gender,
    sterilization: value.sterilization,
  };
}
